import { useDispatch, useSelector } from 'react-redux'
import { AppState } from '../root-reducer'
import { IssueListState } from './types'
import {
  issuesCategoryChangeAction,
  issuesClearAndSetCategoryChangeAction,
  issuesLoadSearch,
  issuesPageChanged,
  issuesPlatformChanged,
  issuesSearchChangeAction,
  setIssues
} from './actions'
import { SearchIssues_searchIssue_docs } from '../../graphql/Issue/__generated__/SearchIssues'

const useIssues = () => {
  const {
    issues, categories, platform, type, loading, search, page
  } = useSelector<
    AppState,
    IssueListState
  >((state) => state.issueList)
  const dispatch = useDispatch()

  const searchIssues = (payload: string) => {
    dispatch(issuesSearchChangeAction(payload))
  }

  const loadSearch = (payload: any) => {
    dispatch(issuesLoadSearch(payload))
  }

  const changeCategories = (payload: string) => {
    dispatch(issuesCategoryChangeAction(payload))
  }

  const changePage = (payload: number) => {
    dispatch(issuesPageChanged(payload))
  }

  const changePlatform = (payload: string) => {
    dispatch(issuesPlatformChanged(payload))
  }

  const addIssues = (payload: SearchIssues_searchIssue_docs[]) => {
    dispatch(setIssues(payload))
  }

  const clearAndSetCategory = (payload: string) => {
    dispatch(issuesClearAndSetCategoryChangeAction(payload))
  }

  return {
    actions: {
      searchIssues,
      changePlatform,
      changeCategories,
      changePage,
      addIssues,
      loadSearch,
      clearAndSetCategory
    },
    issues,
    categories,
    platform,
    loading,
    search,
    type,
    page
  }
}

export default useIssues
